import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css',
  imports: [TranslocoModule, MatDialogModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsComponent {

  terms: any;

  constructor(
    private transloco: TranslocoService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang && ['en', 'sv'].includes(lang)) {
        this.transloco.setActiveLang(lang);
      }
      
      this.transloco
        .selectTranslateObject('TERMS_AND_CONDITIONS')
        .subscribe(result => {
          this.terms = result;
          this.cdr.markForCheck();
        });
    });
  }

  getSafeHtml(html: string) {
    if (typeof html !== 'string') return '';
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  isString(value: any): boolean {
    return typeof value === 'string';
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && value.bullets;
  }

}